import { api, RouteAPI } from "../service/apiService";

export interface AdministrativeArea {
    id: number;
    name: string;
}

export interface Country {
    id: number;
    name: string;
    code: string;
    administrativeAreaName: string;
    administrativeAreas?: AdministrativeArea[];
}

export const fetchCountries = async (): Promise<Country[]> => {
    try {
        const response = await api(RouteAPI.COUNTRY, "GET");

        if (response.status !== 200 || !Array.isArray(response.data)) {
            throw new Error("Invalid response format");
        }

        return response.data;
    } catch (error) {
        console.error("Failed to fetch countries:", error);
        return [];
    }
};

export const fetchCountryById = async (id: number): Promise<Country | null> => {
    try {
        const response = await api(`${RouteAPI.COUNTRY}/${id}`, "GET");

        if (response.status !== 200) {
            throw new Error("Failed to fetch country");
        }

        return response.data;
    } catch (error) {
        console.error("Failed to fetch country:", error);
        return null;
    }
};
